/* eslint-disable */

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import router from './router'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VueSession from 'vue-session'
import VuePassword from 'vue-password'
import moment from 'moment'
import TextHighlight from 'vue-text-highlight'
import DrawerLayout from 'vue-drawer-layout'
import pluralize from 'pluralize'


// import VTooltip from 'v-tooltip'

// Vue.use(VTooltip)
Vue.use(DrawerLayout)
Vue.component('text-highlight', TextHighlight);

Vue.prototype.moment = moment
Vue.prototype.pluralize = pluralize

Vue.component(VuePassword)

Vue.use(Vuetify, {
  // 'md' || 'mdi' || 'fa' || 'fa4'
})

var options = {
  persist: true
}

Vue.use(VueSession, options)

Vue.config.productionTip = false

Vue.mixin({
  data:() =>({
    // api_url : 'http://localhost:8000',
    api_url : 'https://cc.cs.umass.edu:8000',
    org_tagss: [
      {
        id: 'A',
        name: 'Action Item',
        color: '#4286f4'
      },
      {
        id: 'B',
        name: 'Main Issue',
        color: '#FE4540'
      },
      {
        id: 'C',
        name: 'Topic Shift',
        color: '#3BAD57'
      },
      {
        id: 'D',
        name: 'Comment',
        color: '#ae1ced'
      },
      {
        id: 'E',
        name: 'Decision',
        color: '#FF972F'
      },
      {
        id: 'notag',
        name: 'No Tag',
        color: 'lightgray'
      },
    ],
  }),
  methods: {
    getUser() {
      if (!this.$session.exists()) {
        this.$session.start();
      }
      if (this.$session.has("user")) {
        var user = JSON.parse(this.$session.get("user"));
        // console.log("user",user)
        return user;
      }
      return null;
    },
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js